import Icons, { IconsProps } from '../../Icons';

export type LocationOnProps = IconsProps;

/**
 * - sm
 *   - 0.875 rem 14 px
 * - md (defalut)
 *   - 1 rem 16 px
 * - lg
 *   - 1.125 rem 18 px
 * - xl
 *   - 1.25 rem 20 px
 * - xl2 (big)
 *   - 1.5 rem 24 px
 * @param props
 * @returns
 */
export function LocationOn(props: LocationOnProps) {
  return (
    <Icons {...props}>
      <path d="M12 11.4375C12.4167 11.4375 12.7707 11.2915 13.062 10.9995C13.354 10.7082 13.5 10.3542 13.5 9.9375C13.5 9.52083 13.354 9.16683 13.062 8.8755C12.7707 8.5835 12.4167 8.4375 12 8.4375C11.5833 8.4375 11.2293 8.5835 10.938 8.8755C10.646 9.16683 10.5 9.52083 10.5 9.9375C10.5 10.3542 10.646 10.7082 10.938 10.9995C11.2293 11.2915 11.5833 11.4375 12 11.4375ZM12 20.1875C14.0833 18.3708 15.6873 16.5542 16.812 14.7375C17.9373 12.9208 18.5 11.3875 18.5 10.1375C18.5 8.17083 17.871 6.5625 16.613 5.3125C15.3543 4.0625 13.8167 3.4375 12 3.4375C10.1833 3.4375 8.646 4.0625 7.388 5.3125C6.12933 6.5625 5.5 8.17083 5.5 10.1375C5.5 11.3875 6.06267 12.9208 7.188 14.7375C8.31267 16.5542 9.91667 18.3708 12 20.1875ZM12 21.5625C9.46667 19.3125 7.58333 17.2292 6.35 15.3125C5.11667 13.3958 4.5 11.6708 4.5 10.1375C4.5 7.7875 5.25433 5.91683 6.763 4.5255C8.271 3.1335 10.0167 2.4375 12 2.4375C13.9833 2.4375 15.7293 3.1335 17.238 4.5255C18.746 5.91683 19.5 7.7875 19.5 10.1375C19.5 11.6708 18.8833 13.3958 17.65 15.3125C16.4167 17.2292 14.5333 19.3125 12 21.5625Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
